const CoreAppEndPoints =  {
    DOMAIN: "https://portal.cotranscat.com",
    WEB_SOCKET_DOMAIN: "https://portal-socket.cotranscat.com",
    WEB_SOCKET_PRINT: "http://localhost:3300"
    
}

export default CoreAppEndPoints